import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import React from "react";
import { Link } from "react-router-dom";

const Columns = ({ handleRoleStatus, handleEditHandler, deleteHandler, handleViewHandler, handlePermissionHandler, permissions }) => [
  {
    dataField: "roleName",
    text: "Role Name",
    formatter: (_, row) => <span className="text">{row.roleName}</span>,
  },
  {
    dataField: "permissions",
    text: "Permissions",
    formatter: (_, row) => {
      const permissionKeys = row?.permissions?.map((p) => p.permissionKey) || [];

      if (!permissionKeys.length) {
        return <span>-</span>;
      }

      const tooltip = (
        <Tooltip id={`permissions-tooltip-${row._id}`}>
          <div style={{ textAlign: "left" }}>
            {permissionKeys.map((key, idx) => (
              <div key={idx}>{key}</div>
            ))}
          </div>
        </Tooltip>
      );

      return (
        <OverlayTrigger placement="top" overlay={tooltip}>
          <i
            className="fas fa-info-circle"
            style={{ fontSize: "16px", cursor: "pointer", color: "#6c757d" }}
          ></i>
        </OverlayTrigger>
      );
    },
  },
  {
    text: "Created At",
    dataField: "date_created_utc",
    formatter: (_, row) => row.createdAt && DATE_FORMAT(row.createdAt),
  },
  {
    dataField: "status", // unique, not "status"
    text: "Status",
    formatter: (_, row) => {
      const isActive = row?.status === "active";

      return isActive ? (
        <button
          className="fas fa-toggle-on"
          style={{
            fontSize: "20px",
            color: "green",
            backgroundColor: "#fff",
            border: "none",
          }}
          title="Active"
          onClick={() => handleRoleStatus(row, "inactive")}
        ></button>
      ) : (
        <button
          className="fas fa-toggle-off"
          style={{
            fontSize: "20px",
            color: "red",
            backgroundColor: "#fff",
            border: "none",
          }}
          title="Inactive"
          onClick={() => handleRoleStatus(row, "active")}
        ></button>
      );
    },
  },
  {
    text: "Add/Remove Permission",
    dataField: "managePermissions",
    formatter: (_, row) => {
      return (
        <button
          className="fas fa-user-shield"
          style={{ fontSize: "16px", backgroundColor: "#fff", border: "none" }}
          title="Add/Remove Permission"
          onClick={() => handlePermissionHandler(row)}
        ></button>
      );
    },
  },
  {
    text: "Action",
    dataField: "action",
    formatter: (_, row) => (
      <>
        <button
          className="fas fa-eye"
          style={{
            fontSize: "16px",
            backgroundColor: "#fff",
            border: "none",
          }}
          title="View"
          onClick={() => handleViewHandler(row)}
        ></button>
        {permissions?.edit ?
          <button
            className="fas fa-pen"
            style={{
              fontSize: "16px",
              backgroundColor: "#fff",
              border: "none",
            }}
            title="Edit"
            onClick={() =>
              handleEditHandler(row)
            }
          ></button>
          : null}
        {permissions?.delete ? (
          <button
            className="fas fa-trash-alt"
            style={{
              backgroundColor: "#fff",
              border: "none",
            }}
            title="Delete"
            onClick={() => deleteHandler(row._id)}
          ></button>
        ) : null}
      </>
    ),
  },
];
export default Columns;
